module.exports = __webpack_public_path__ + "media/images/element/18-d6d73cfd0980999c7cb580e4c82b5ab3.svg";